export default function shinySelect($rootScope, API, UserCache) {
  'ngInject'
  var directive = {
    restrict: 'E',
    scope: {
      tags: '=tags',
      multiple: '=multiple',
    },
    template: '<input type="hidden" class="bigdrop" id="shinySelect" style="width:400px;"/>',
    link: selectLink,
  }

  return directive

  function selectLink($scope, $element, $attr) {
    var auth = UserCache.getObject()
    $.ajaxSetup({
      headers: {
        'X-Collectible-Platform': 'QP2',
        Authorization: 'Bearer ' + auth.jwt,
      },
    })
    $('#shinySelect').select2({
      ajax: {
        url: function (t, page) {
          var start, limit
          if (page === 1) {
            start = 0
            limit = 25
          } else {
            limit = page * 25
            start = limit - 25
          }
          return API.API_URL + 'admin/shinies/search?start=' + start + '&limit=' + 25
        },
        dataType: 'json',
        quietMillis: 250,
        data: function (t, page) {
          if ($rootScope.collectibleType === 'channel') {
            return {
              page: page,
              chId: t,
            }
          } else if ($rootScope.collectibleType === 'set') {
            return {
              page: page,
              sId: t,
            }
          } else if ($rootScope.collectibleType === 'collectible') {
            return {
              page: page,
              qId: t,
            }
          } else {
            return {
              page: page,
              t: t,
              sTi: t,
              chTi: t,
            }
          }
        },
        results: function (data, page) {
          $rootScope.$broadcast('shinyList', data.results)
          return {
            results: data.results,
            more: page + 25 < data.ct,
          }
        },
      },
      multiple: $scope.multiple,
      escapeMarkup: function (markup) {
        return markup
      }, // let our custom formatter work
      minimumInputLength: 1,
      formatResult: formatState,
      formatSelection: formatStateSelection,
    })

    function formatState(state) {
      if (state.loading) {
        return state.text
      }

      var statusType = function (st) {
        switch (st) {
          case 0:
            return 'Draft'
          case 1:
            return 'Published'
          case 2:
            return 'Sold Out'
          case 3:
            return 'Unavailable'
          case 4:
            return 'Awaiting Collectible Count'
          default:
            break
        }
      }

      var markup =
        "<div class='select2-result-repository clearfix'>" +
        "<div class='select2-result-repository__meta'>" +
        "<div class='select2-result-repository__title'>" +
        "<div style='font-size: 12px; color: #333; opacity: 0.9;'>Channel: <b>" +
        state.q.s.ch.t +
        '</b></div>' +
        "<div style='font-size: 12px; color: #333; opacity: 0.9;'>Set: <b>" +
        state.q.s.t +
        '</b></div>' +
        "<div style='font-size: 12px; color: #333; opacity: 0.9;'>Collectible: <b>" +
        state.q.t +
        '</b></div>' +
        "<div style='font-size: 12px; color: #333; opacity: 0.9;'>Collectible Status: <b>" +
        statusType(state.q.st) +
        '</b></div>' +
        "<div style='font-size: 12px; color: #333; opacity: 0.9;'>ID: <b>" +
        state.id +
        '</b></div>' +
        "<div style='font-size: 12px; color: #333; opacity: 0.9;'>Title: <b>" +
        state.t +
        '</b></div>'
      '</div>' + '</div></div>'

      return markup
    }

    function formatStateSelection(state) {
      return state.id + ': ' + state.t
    }
  }
}
